import { getGlobal, setGlobal } from './persistence/global';
import { AppSettingTypeMap } from './AppSettingTypeMap';

const typeMetadataQFStateKey = 'quickFetchedTypeMetadataRequests';

type TypeMetadataQuickFetchesMap = Map<string, Promise<AppSettingTypeMap>>;

export const getTypeMetadataQuickFetches = (): TypeMetadataQuickFetchesMap =>
  getGlobal(typeMetadataQFStateKey) || new Map();

export const setTypeMetadataQuickFetches = (
  value: TypeMetadataQuickFetchesMap | null
) => setGlobal(typeMetadataQFStateKey, value);

const removeTypeMetadataQuickFetch = (appSettingName: string) => {
  const quickFetches = getTypeMetadataQuickFetches();

  quickFetches.delete(appSettingName);

  setTypeMetadataQuickFetches(quickFetches);
};

export const takeTypeMetadataQuickFetch = (appSettingName: string) => {
  const quickFetches = getTypeMetadataQuickFetches();
  const value = quickFetches.get(appSettingName);

  removeTypeMetadataQuickFetch(appSettingName);

  return value;
};
